/**
 * Hotspot Viewer App
 * Displays interactive hotspots on showroom display images
 */

import { createApp } from 'vue';
import HotspotViewer from './components/HotspotViewer.vue';

document.addEventListener('DOMContentLoaded', () => {
	const containers = document.querySelectorAll('[data-hotspot-viewer]');

	containers.forEach(container => {
		const dataAttr = container.dataset.hotspotData;
		if (!dataAttr) {
			console.warn('Hotspot viewer: Missing data-hotspot-data attribute');
			return;
		}

		try {
			const data = JSON.parse(dataAttr);

			// Validate required data
			if (!data.image || !data.image.url || !data.image.width || !data.image.height) {
				console.warn('Hotspot viewer: Invalid image data');
				return;
			}

			if (!data.items || !Array.isArray(data.items)) {
				data.items = [];
			}

			if (!data.hotspots || !Array.isArray(data.hotspots)) {
				data.hotspots = [];
			}

			// Only mount if there are hotspots to display
			if (data.hotspots.length === 0) {
				console.info('Hotspot viewer: No hotspots defined, skipping mount');
				return;
			}

			const app = createApp(HotspotViewer, {
				image: data.image,
				items: data.items,
				hotspots: data.hotspots,
				imageAlt: container.dataset.imageAlt || 'Display with hotspots',
			});

			app.mount(container);
		} catch (e) {
			console.error('Hotspot viewer: Failed to parse data', e);
		}
	});
});
